module.exports = __webpack_public_path__ + "img/Communication.20285335.png";